<div class="info-dialog-container">
  <div class="fs-lg" style="font-weight: 400">
    {{ data.text }}
  </div>
  <div class="title-f">
    {{ data.textBold }}
  </div>
</div>
